import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import i18n, { isRtlLanguage } from './i18n'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'

const savedLang = i18n.resolvedLanguage || i18n.language || localStorage.getItem('i18nextLng') || 'en';
const isRtl = isRtlLanguage(savedLang);
document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
document.documentElement.lang = savedLang;

const bootstrapPromise = isRtl
  ? import('bootstrap/dist/css/bootstrap.rtl.min.css')
  : import('bootstrap/dist/css/bootstrap.min.css');

bootstrapPromise.then(async () => {
  await import('./bootstrap-overrides.css');

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
});
